import React from 'react';
import PropTypes from 'prop-types';
import ProductTiles from './ProductTiles';


const CartRecommendations = function CartRecommendationsComponent({
  products, productLimit, title,
}) {
  if (!(products && products.length > 0)) {
    return null;
  }

  return (
    <div className="cart-recommendations">
      <div className="cart-recommendations__body">
        <div className="cart-recommendations__header">
          <div className="cart-recommendations__title" role="heading" aria-level={2}>{title}</div>
        </div>
        <div className="cart-recommendations__wrapper">
          <ProductTiles productLimit={productLimit} products={products} />
        </div>
      </div>
    </div>
  );
};

CartRecommendations.propTypes = {
  title: PropTypes.string.isRequired,
  productLimit: PropTypes.number.isRequired,
  products: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};

export default CartRecommendations;
